import React from 'react';
import {connect} from 'react-redux';
import {cloakingDomainAction} from '../../../store/actions/cloakingDomainAction';
import CloakingDomainsList from './CloakingDomainsList';
import AddCloakingDomain from './AddCloakingDomain';
import DomainManager from './DomainManager';

export const CloakingDomains = props => <DomainManager {...props} kind="cloaking"
    description="Hide your traffic source and landing page domain from affiliate networks." data={props.state.cloakingDomains}
    Form={AddCloakingDomain} List={CloakingDomainsList} load={props.loadCloakingDomains} resetDomain={props.setCloakingDomain}/>;

export default connect(state => ({state: state.cloakingDomain}), {
    loadCloakingDomains: cloakingDomainAction.fetch,
    addAndVerify: cloakingDomainAction.addAndVerify,
    clearErrors: cloakingDomainAction.clearErrors,
    setActiveStep: cloakingDomainAction.setStep,
    setCloakingDomain: cloakingDomainAction.setCloakingDomain
})(CloakingDomains);
